import { useState, useEffect } from 'react';
import { IAutomatedEmailCampaignSetting, getAutomatedEmailSettingForJob } from 'wisestep-api';

export const useGetEmailSettingForJob = (jobId: string) => {
  const [emailCampaignSettingForJob, setEmailCampaignSettingForJob] =
    useState<IAutomatedEmailCampaignSetting>({} as IAutomatedEmailCampaignSetting);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await getAutomatedEmailSettingForJob(jobId);
        if (data) {
          setEmailCampaignSettingForJob(data);
        }
      } catch {
        console.error('Error while getting the setting campaign list');
      }
    })();
  }, [jobId]);

  return { emailCampaignSettingForJob };
};
